import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from './common/LoadingSpinner';
import { AccessDenied } from './ProtectedRoute';
import { canOpenPage } from '../utils/pagePermissions';
import SignedOutRedirect from './SignedOutRedirect';

// Where to send users whose role cannot open the dashboard (first page they can open wins;
// account settings are open to everyone)
const RETAIL_HOMES = [
  '/sales/new',
  '/sales',
  '/products',
  '/customers',
  '/calculator',
  '/tasks',
  '/settings/account'
];
const WHOLESALE_HOMES = [
  '/wholesale/orders',
  '/wholesale/distributors',
  '/wholesale/products',
  '/wholesale/settings/account'
];
const DASHBOARD_FALLBACKS = {
  '/dashboard': RETAIL_HOMES,
  '/retail/dashboard': RETAIL_HOMES,
  '/wholesale/dashboard': WHOLESALE_HOMES
};

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  // Show loading state while checking authentication
  if (loading) {
    return <LoadingSpinner message="Loading..." className="min-h-screen" />;
  }

  // Not signed in: the login page, or One Manager for people who came from it
  if (!isAuthenticated) {
    return <SignedOutRedirect />;
  }

  // Pages without their own guard still follow the role's permissions
  if (canOpenPage(user, location.pathname) === false) {
    // Login lands on the dashboard; roles without it go to the first page they can open
    const fallbacks = DASHBOARD_FALLBACKS[location.pathname];
    if (fallbacks) {
      const home = fallbacks.find((path) => canOpenPage(user, path) !== false);
      if (home) return <Navigate to={home} replace />;
    }
    return <AccessDenied />;
  }

  // Render children if authenticated
  return children;
};

export default PrivateRoute;
